export default __webpack_public_path__ + "static/media/basket.c16a54cb.png";